import Vue from 'vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Inputs from '../admin/components/inputs.vue'
import Mixin from '../admin/js/mixin'
import filters from '../admin/js/filter'
import Pagination from '../admin/components/pagination.vue'
import 'vuetify/dist/vuetify.min.css'
import '../admin/scss/main.scss'
import mSwitch from '../admin/components/mSwitch.vue'
import snackbar from '../admin/components/snackbar.vue'
import confirm from '../admin/components/confirm.vue'
import Vuetify from 'vuetify'
Vue.use(Vuetify, {
  theme: {
    primary: '#0091FF',
    secondary: '#26A69A',
    accent: '#0091FF',
    error: '#F44336',
    warning: '#ffeb3b',
    info: '#2196F3',
    success: '#4CAF50'
  }
})

Vue.component('snackbar', snackbar)
Vue.component('confirm', confirm)
Vue.component('m-switch', mSwitch)
Vue.component('inputs', Inputs)
Vue.component('pagination', Pagination)
for (let name in filters) {
  Vue.filter(name, filters[name])
}
Vue.mixin(Mixin)




// WEBPACK FOOTER //
// ./src/init/admin.js